(() => {
  const initialise = () => {
    const dialog = document.querySelector('[data-ebike-delivery-promotion]');
    if (!dialog || dialog.dataset.initialised === 'true') return;
    dialog.dataset.initialised = 'true';
    const campaign = dialog.dataset.offerCode;
    const storageKey = 'ebikebuyer:delivery-offer:' + campaign;
    window.ebikeBuyerDeliveryOffer = {
      code: campaign,
      active: () => dialog.isConnected && dialog.dataset.eligible === 'true'
    };
    if (typeof dialog.showModal !== 'function') return;
    const close = () => dialog.close();
    dialog.querySelectorAll('[data-delivery-promotion-close]').forEach(button => {
      button.addEventListener('click', close);
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ebike-delivery-promotion-open');
    });
    let pressedBackdrop = false;
    const outside = event => {
      if (event.target !== dialog) return false;
      const box = dialog.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    };
    dialog.addEventListener('pointerdown', event => { pressedBackdrop = outside(event); });
    dialog.addEventListener('click', event => {
      if (pressedBackdrop && outside(event)) close();
      pressedBackdrop = false;
    });
    dialog.querySelector('[data-delivery-promotion-details]').addEventListener('click', () => {
      close();
      const details = document.getElementById(dialog.dataset.detailsId);
      const trigger = details?.parentElement.querySelector('[data-ebike-delivery-details-trigger]');
      if (trigger) requestAnimationFrame(() => trigger.click());
    });
    if (dialog.dataset.designMode === 'true') return;
    let alreadyShown = window.ebikeBuyerDeliveryOfferShown === campaign;
    try { alreadyShown = alreadyShown || sessionStorage.getItem(storageKey) === 'shown'; } catch (_) {}
    if (alreadyShown) return;
    const open = () => {
      if (!dialog.isConnected || document.visibilityState !== 'visible') return;
      if (document.querySelector('dialog[open], .ebike-offer-modal.is-open, .ebike-reserve-modal.is-open, .ebike-question-modal.is-open')) return;
      dialog.showModal();
      document.documentElement.classList.add('ebike-delivery-promotion-open');
      window.ebikeBuyerDeliveryOfferShown = campaign;
      try { sessionStorage.setItem(storageKey, 'shown'); } catch (_) {}
    };
    setTimeout(open, 450);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
